import { render } from "./BaseIcon.vue?vue&type=template&id=61b7413f&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=61b7413f&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b7413f"]])

export default __exports__